module.exports = __webpack_public_path__ + "img/vu.e2349f70.svg";